const replaceModelFamily = (modelFamily: string, modelName: string) => {
  if (modelName.includes('all-new A5')) return 'A5new';
  if (modelName.includes('all-new S5')) return 'S5new';
  if (modelName.includes('all-new Q5')) return 'Q5new';
  if (modelName.includes('all-new SQ5')) return 'SQ5new';
  if (modelFamily === 'Q4') return 'Q4 e-tron';
  if (modelFamily === 'Q6') return 'Q6 e-tron';
  if (modelFamily === 'SQ6') return 'SQ6 e-tron';
  // if (modelFamily === 'A6') return 'A6 e-tron';
  // if (modelFamily === 'S6') return 'S6 e-tron';
  return modelFamily;
};

export const adjustModelName = (modelName: string, year: number, lang: string) => {
  if (modelName.includes('all-new') && lang === 'fr')
    return `Le tout nouveau Audi ${modelName.replace('all-new', '')} ${year}`;
  return `${year} Audi ${modelName}`;
};

export const adjustBodyType = (initialBody: string) => {
  if (initialBody.includes('allroad')) return 'allroad quattro';
  return initialBody;
};

export default replaceModelFamily;
